<div class="grid">
    <div class="col-12">
        <div class="card">
            <h4>Editar Menu</h4>
            <form #f="ngForm" name="form" novalidate>
                <div class="p-fluid p-formgrid grid" *ngIf="loadingMenu">
                    <div class="field col-12 md:col-12">
                        <p-divider></p-divider>
                    </div>
                </div>
                <div class="flex justify-content-center" *ngIf="loadingMenu">
                    <p-progressSpinner></p-progressSpinner>
                </div>
                <div class="formgroup" *ngIf="menu">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div class="field col-12 md:col-6">
                            <label htmlFor="descricao">Descrição</label>
                            <input
                                type="text"
                                pInputText
                                placeholder="Insira a descrição do Menu"
                                name="descricao"
                                ngModel
                                #descricao="ngModel"
                                required
                                [(ngModel)]="menu.descricao"
                            />
                            <div
                                *ngIf="descricao.hasError('required') && descricao.touched"
                                class="alerta"
                            >
                                <small>Campo obrigatório</small>
                            </div>
                        </div>

                        <div class="field col-12 md:col-6">
                            <label htmlFor="url">URL</label>
                            <input
                                type="text"
                                pInputText
                                placeholder="Insira a URL"
                                name="url"
                                ngModel
                                #url="ngModel"
                                [(ngModel)]="menu.url"
                            />
                        </div>

                        <div class="field col-12 md:col-6">
                            <label htmlFor="icon">Ícone</label>
                            <input
                                type="text"
                                pInputText
                                placeholder="Insira o ícone"
                                name="icon"
                                ngModel
                                #icon="ngModel"
                                required
                                [(ngModel)]="menu.icon"
                            />
                            <div *ngIf="icon.hasError('required') && icon.touched" class="alerta">
                                <small>Campo obrigatório</small>
                            </div>
                        </div>

                        <div class="field col-12 md:col-6">
                            <label htmlFor="posicaoExibicao">Posição de Exibição</label>
                            <input
                                type="number"
                                pInputText
                                name="posicaoExibicao"
                                ngModel
                                #posicaoExibicao="ngModel"
                                required
                                [(ngModel)]="menu.posicaoExibicao"
                            />
                            <div
                                *ngIf="
                                    posicaoExibicao.hasError('required') && posicaoExibicao.touched
                                "
                                class="alerta"
                            >
                                <small>Campo obrigatório</small>
                            </div>
                        </div>

                        <div class="field col-12 md:col-4">
                            <label htmlFor="menuId">Menu</label>
                            <p-dropdown
                                [options]="listaMenus"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Selecione"
                                [filter]="true"
                                emptyFilterMessage="Nenhum registro"
                                [(ngModel)]="menu.menuId"
                                name="menuId"
                                ngModel
                                #menuId="ngModel"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="permissao">Permissão</label>
                            <p-dropdown
                                [options]="permissoes"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Selecione"
                                [filter]="true"
                                emptyFilterMessage="Nenhum registro"
                                [(ngModel)]="menu.permissao"
                                name="permissao"
                                ngModel
                                #permissao="ngModel"
                                [required]="true"
                            ></p-dropdown>
                            <div
                                *ngIf="permissao.hasError('required') && permissao.touched"
                                class="alerta"
                            >
                                <small>Campo obrigatório</small>
                            </div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="status">Status</label>
                            <br />
                            <p-inputSwitch name="status" [(ngModel)]="menu.status"></p-inputSwitch>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="exclusivoRfarias">Exclusivo Rfarias</label>
                            <br />
                            <p-inputSwitch
                                name="exclusivoRfarias"
                                [(ngModel)]="menu.exclusivoRfarias"
                            ></p-inputSwitch>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
                            <button
                                type="submit"
                                pButton
                                icon="pi pi-check"
                                label="Atualizar"
                                (click)="atualizar()"
                                class="p-button-success mt-5"
                                [disabled]="!f.valid"
                            ></button>
                        </div>
                        <div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
                            <button
                                type="submit"
                                pButton
                                icon="pi pi-spin pi-spinner"
                                label="Atualizando..."
                                class="p-button-success mt-5"
                                [disabled]="true"
                            ></button>
                        </div>
                        <div class="field col-12 md:col-8"></div>
                        <div class="field col-12 md:col-2">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-primary mt-5"
                                routerLink="/rfarias/menu"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
